import {
  Cell,
  Grid,
  Row,
} from '@material/react-layout-grid';
import './LayoutGrid.scss';

/**
 * LayoutGrid MCWR Component
 *
 * @version ./package.json
 */
export default Grid;

export {
  Cell,
  Row,
};
